// @flow
import React from "react";
import { Card, Button, CardTitle, Form, FormGroup, Col } from "reactstrap";
import { useSelector } from "react-redux";
import { useCurrentRoute, useNavigation } from "react-navi";
import { useConfig, useConfigImages } from "../../hooks/configHooks";
import PrintSettings from "../Configuration/config-form-sections/PrintSettings";
import ApplicationCustomization from "../Configuration/config-form-sections/ApplicationCustomization";
import ActiveModeSettings from "../Configuration/config-form-sections/ActiveModeSettings";
import ModeSelection from "../Configuration/config-form-sections/config-form-subsections/ModeSelection";
import Loading from "../loading";
import templateService from "../../services/api/templateService";
import TemplateSettings from "./template-form-sections/TemplateSettings";
import GameSettings from "../Configuration/config-form-sections/GameSettings";


export function TemplateForm(props) {
  const route = useCurrentRoute();
  const navigation = useNavigation();

  const config = useSelector(state => {
    return state.configReducer.config;
  });

  const { isEditing, machineId, config: routeConfig } = route.data;

  useConfig(isEditing, null, routeConfig);
  useConfigImages(isEditing);

  async function handleSubmit(event) {
    event.persist();
    event.preventDefault();
    const formData = new FormData();

    // Adding data to form
    const configKeys = Object.keys(config);
    for (let i = 0; i < configKeys.length; i += 1) {
      if (
        config[configKeys[i]] !== "" &&
        !["eventId", "eventName"].includes(configKeys[i]) // we don't want to include these in the template
      ) {
        formData.append(configKeys[i], config[configKeys[i]]);
      }
    }

    if (route.data.isEditing) {
      templateService.updateTemplate(config._id, formData);
    } else {
      templateService.createTemplate(formData);
    }
    navigation.navigate("/templates");
  }
  const gameset = config.setting ==1 ? (<GameSettings/>) : null ;
  return (
    <div className="mt-5 mb-5 container d-flex justify-content-center">
      <Card outline color="dark" className="card-black p-3 col-md-11">
        <CardTitle className="d-flex justify-content-center">
          <b>Please fill in the form below.</b>{" "}
        </CardTitle>
        <hr className="hr-black" />
        <Form onSubmit={handleSubmit}>
          <ModeSelection />
          <TemplateSettings />
          <ActiveModeSettings setting={config.setting} />
          <PrintSettings />
          {gameset}
          <ApplicationCustomization />
          <FormGroup check row className=" mb-3 d-flex justify-content-center">
            <Col>
              <Button
                outline
                className=" btn-black btn-block btn btn-outline-dark"
                type="submit"
              >
                Submit
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Card>
    </div>
  );
}
export default TemplateForm;



// WEBPACK FOOTER //
// ./src/views/template/templateForm.jsx